
(function(){

    //
    // Get meta variable
    //
    function get_meta(name){

        let meta = document.head.querySelector('meta[name="' + name + '"]');

        if(!meta){
            console.error('No meta[name="' + name + '"] in the current view');
            return null;
        }

        return meta.content;
    }

    //
    // Set stuff in the meta
    //
    //$(function(){
        window.ws.portal_name        = get_meta('portal-name');
        window.ws.portal_environment = get_meta('portal-environment');
        window.ws.portal_version     = get_meta('portal-version');
        window.ws.csrf_token         = get_meta('csrf-token');
    //});


})(); // End auto-executable anonymous function


